import { TimeFrameOption } from '../types';

export const numberToMonthName = {
  0: 'Jan',
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'Jun',
  6: 'Jul',
  7: 'Aug',
  8: 'Sep',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec',
};

export const monthNameToNumber = Object.keys(numberToMonthName).reduce((acc, key) => {
  acc[numberToMonthName[key]] = key;
  return acc;
}, {});

export const timeFrameToDate = (timeFrame: TimeFrameOption) => {
  const [month, year] = timeFrame.label.split(' ');
  return new Date(parseInt(year), monthNameToNumber[month]);
};

export const dateToTimeFrame = (date: Date, availableMonths: TimeFrameOption[]) => {
  return {
    timeFrame: availableMonths.find(el => {
      const [month, year] = el.label.split(' ');
      return numberToMonthName[date.getMonth()] === month && date.getFullYear() === parseInt(year);
    }),
    date,
  };
};
